import React from "react";

const SpinnerPage = () => {
  return (
    <>
      <div class="spinner-border text-primary" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </>
  );
}

export default SpinnerPage;